export default { sha: '2babbeb653e8343c37f4e61cc24b4e578f33ef49', buildNumber: 'undefined' }
